import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { SaveScheduledMaintenanceResponse as SaveScheduledMaintenanceResponse,
     GetScheduledMaintenanceResponse, 
     DeleteScheduledMaintenanceResponse, 
     GetNextScheduledMaintenanceResponse, 
     SaveScheduledMaintenanceRequest, 
     CompleteScheduledMaintenanceResponse, 
     ForceStartOfScheduledMaintenanceResponse, 
     DeleteScheduledMaintenanceRequest,
     CompleteScheduledMaintenanceRequest,
     ForceStartOfScheduledMaintenanceRequest} from "../../models/basics/scheduled-maintenance.models";
import { ScheduledMaintenanceRoutes } from "../../constants/scheduled-maintenance/scheduled-maintenance.constants";

@autoinject
export class ScheduledMaintenanceService{
    constructor(private requestClient: RequestClientService){} 

    public saveScheduledMaintenance(request: SaveScheduledMaintenanceRequest): Promise<SaveScheduledMaintenanceResponse>{
        return this.requestClient.post<SaveScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.BaseUrl, {}, request);
    }

    public getScheduledMaintenanceById(id: number): Promise<GetScheduledMaintenanceResponse>{
        return this.requestClient.get<GetScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.BaseUrl + id);
    }

    public deleteScheduledMaintenance(request: DeleteScheduledMaintenanceRequest): Promise<DeleteScheduledMaintenanceResponse>{
        return this.requestClient.delete<DeleteScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.BaseUrl, {}, request);
    }

    public getNextScheduledMaintenance(): Promise<GetNextScheduledMaintenanceResponse>{
        return this.requestClient.get<GetNextScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.GetNextScheduledMaintenance);
    }

    public completeScheduledMaintenance(request: CompleteScheduledMaintenanceRequest): Promise<CompleteScheduledMaintenanceResponse>{
        return this.requestClient.post<CompleteScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.CompleteScheduledMaintenance, {}, request);
    }

    public forceStart(request: ForceStartOfScheduledMaintenanceRequest): Promise<ForceStartOfScheduledMaintenanceResponse>{
        return this.requestClient.post<ForceStartOfScheduledMaintenanceResponse>(ScheduledMaintenanceRoutes.ForceStart, {}, request);
    }
}